import { isNew } from "@/common/config"
import ApiService from "@/utils/request"

export const appServe = {
  testLogin(id) {
    return ApiService.post(`login/test-login/?id=${id}`)
  },
  getRcYunUserInfoByRcId(id) {
    return ApiService.get(`alumni/info/rc/${id}/`)
  },
  // reward 获取用户信息
  getUserInfo() {
    return ApiService.query(`login/user/info/`, { isNew })
  },
  getUserCenterInfo() {
    return ApiService.query(`rencai/home/center/`, { isNew })
  },
  // 获取人才证书
  getRdCert(params) {
    return ApiService.query(`rd/inst/getCertDetail`, params)
  },
  // 获取入选证书
  getSelectedCert(params) {
    return ApiService.query(`rd/inst/pool/getCertDetail`, params)
  },
  // 无政务网个人登录
  authPidpwdPost(params) {
    return ApiService.post(`dg_pubuser/auth/pidpwd`, params)
  },
  // 无政务网法人登录
  authPidpwdLegalPost(params) {
    return ApiService.post(`dg_pubuser/auth/pidpwd/legal`, params)
  },
  // 获取人才码
  getRdCode() {
    return ApiService.query(`rd/inst/getCertQr`)
  },
  authRczjQuery(params) {
    return ApiService.query(`dg_pubuser/auth/rczj`, params)
  }
}

export const fileServe = {
  getFileInfo(id) {
    return ApiService.query(`file/zlb_file_name`, { id })
  }
}
